import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { WEB_APIS } from "../../../utils/APIS";
import { GET, POST, PUT, DELETE } from "../../../utils/Methods";
import { IDS } from "../../../utils/IDS";

// report - Get All (Read)
export const GetDailySummary = createAsyncThunk(
    "masters/report/get-all-dailySummary",
    async (filter, { rejectWithValue }) => {
        try {
            const res = await GET(
                `${WEB_APIS.Report.DailySummary}?name=${filter?.name || ""}&page=${filter?.page || IDS.PAGE
                }&per_page=${filter?.per_page || IDS.PERPAGE}&status=${filter?.status || ""}&startDate=${filter?.startDate || ""}&endDate=${filter?.endDate || ""}`
            );
            return res;
        } catch (error) {
            return rejectWithValue(error.message);
        }
    }
);
export const GetAllPartyWiseOutStanding = createAsyncThunk(
    "masters/report/get-all-partyWiseOutStanding",
    async (filter, { rejectWithValue }) => {
        try {
            const res = await GET(
                `${WEB_APIS.Report.PartyWiseOutStanding}?name=${filter?.name || ""}&page=${filter?.page || IDS.PAGE
                }&per_page=${filter?.per_page || IDS.PERPAGE}&status=${filter?.status || ""}&startDate=${filter?.startDate || ""}&endDate=${filter?.endDate || ""}`
            );
            return res;
        } catch (error) {
            return rejectWithValue(error.message);
        }
    }
);
export const GetAllTaxSummary = createAsyncThunk(
    "masters/report/get-all-taxSummary",
    async (filter, { rejectWithValue }) => {
        try {
            const res = await GET(
                `${WEB_APIS.Report.TaxSummary}?name=${filter?.name || ""}&page=${filter?.page || IDS.PAGE
                }&per_page=${filter?.per_page || IDS.PERPAGE}&status=${filter?.status || ""}&startDate=${filter?.startDate || ""}&endDate=${filter?.endDate || ""}`
            );
            return res;
        } catch (error) {
            return rejectWithValue(error.message);
        }
    }
);
export const GetAllInventoryStock = createAsyncThunk(
    "masters/report/get-all-inventoryStock",
    async (filter, { rejectWithValue }) => {
        try {
            const res = await GET(
                `${WEB_APIS.Report.InventoryStock}?name=${filter?.name || ""}&page=${filter?.page || IDS.PAGE
                }&per_page=${filter?.per_page || IDS.PERPAGE}&startDate=${filter?.startDate || ""}&endDate=${filter?.endDate || ""}`
            );
            return res;
        } catch (error) {
            return rejectWithValue(error.message);
        }
    }
);
export const GetAllSalesPurchase = createAsyncThunk(
    "masters/report/get-all-salesPurchase",
    async (filter, { rejectWithValue }) => {
        try {
            const res = await GET(
                `${WEB_APIS.Report.SalesPurchase}?name=${filter?.name || ""}&page=${filter?.page || IDS.PAGE
                }&per_page=${filter?.per_page || IDS.PERPAGE}&startDate=${filter?.startDate || ""}&endDate=${filter?.endDate || ""}`
            );
            return res;
        } catch (error) {
            return rejectWithValue(error.message);
        }
    }
);

export const DowloadPdfInventoryStock = createAsyncThunk(
    "masters/report/get-all-download-psdf",
    async (filter, { rejectWithValue }) => {
        try {
            const res = await GET(
                `${WEB_APIS.Report.InventoryStock}-pdf?name=${filter?.name || ""}&page=${filter?.page || IDS.PAGE
                }&per_page=${filter?.per_page || IDS.PERPAGE}&startDate=${filter?.startDate || ""}&endDate=${filter?.endDate || ""}`
            );
            return res;
        } catch (error) {
            return rejectWithValue(error.message);
        }
    }
);
export const DowloadXLsInventoryStock = createAsyncThunk(
    "masters/report/get-all-download-xls",
    async (filter, { rejectWithValue }) => {
        try {
            const res = await GET(
                `${WEB_APIS.Report.InventoryStock}-xls?name=${filter?.name || ""}&page=${filter?.page || IDS.PAGE
                }&per_page=${filter?.per_page || IDS.PERPAGE}&startDate=${filter?.startDate || ""}&endDate=${filter?.endDate || ""}`
            );
            return res;
        } catch (error) {
            return rejectWithValue(error.message);
        }
    }
);

export const GetStockValueReport = createAsyncThunk(
    "masters/report/get-all-stockValueReport",
    async (filter, { rejectWithValue }) => {
        try {
            const res = await GET(
                `${WEB_APIS.Report.StockValueReport}?name=${filter?.name || ""}&page=${filter?.page || IDS.PAGE
                }&per_page=${filter?.per_page || IDS.PERPAGE}&category_id=${filter?.category_id || ""}&startDate=${filter?.startDate || ""}&endDate=${filter?.endDate || ""}`
            );
            return res;
        } catch (error) {
            return rejectWithValue(error.message);
        }
    }
);

export const GetPartyReportByItem = createAsyncThunk(
    "masters/report/get-all-partyReportByItem",
    async ({ id, filter }, { rejectWithValue }) => {
        try {
            const res = await GET(
                `${WEB_APIS.Report.PartyReportByItem}/${id}?name=${filter?.name || ""}&page=${filter?.page || IDS.PAGE
                }&per_page=${filter?.per_page || IDS.PERPAGE}&category_id=${filter?.category_id || ""}&startDate=${filter?.startDate || ""}&endDate=${filter?.endDate || ""}`
            );
            return res;
        } catch (error) {
            return rejectWithValue(error.message);
        }
    }
);


export const GetSalesReport = createAsyncThunk(
    "masters/report/get-all-salesReport",
    async (filter, { rejectWithValue }) => {
        try {
            const res = await GET(
                `${WEB_APIS.Report.SalesReport}?name=${filter?.name || ""}&page=${filter?.page || IDS.PAGE
                }&per_page=${filter?.per_page || IDS.PERPAGE}&party_id=${filter?.party_id || ""}&payment_status_id=${filter?.status || ""}&startDate=${filter?.startDate || ""}&endDate=${filter?.endDate || ""}`
            );
            return res;
        } catch (error) {
            return rejectWithValue(error.message);
        }
    }
);
export const GetSalesReportByParty = createAsyncThunk(
    "masters/report/get-all-salesReportByParty",
    async (filter, { rejectWithValue }) => {
        try {
            const res = await GET(
                `${WEB_APIS.Report.SalesReportByParty}?name=${filter?.name || ""}&page=${filter?.page || IDS.PAGE
                }&per_page=${filter?.per_page || IDS.PERPAGE}&party_id=${filter?.party_id || ""}&payment_status_id=${filter?.status || ""}&startDate=${filter?.startDate || ""}&endDate=${filter?.endDate || ""}`
            );
            return res;
        } catch (error) {
            return rejectWithValue(error.message);
        }
    }
);




export const Slice = createSlice({
    name: "report",
    initialState: {
        data: [],
        inventory_stock: [],
        sales_purchase: [],
        tax_summary: [],
        party_wise_outStanding: [],
        daily_summary: [],
        stock_value_report: [],
        party_report_by_item: [],
        sales_report: [],
        sales_report_by_party: [],
        current_page: IDS.PAGE,
        total_pages: IDS.TOTALPAGES,
        per_page: IDS.PERPAGE,
        total: IDS.TOTAL,
        status: IDS.SLICESTATUS.Idle,
        error: null,
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            // Handling all actions for GetSingle, Create, Update, Delete
            .addCase(GetSalesReportByParty.pending, (state) => {
                state.status = IDS.SLICESTATUS.Loading;
            })
            .addCase(GetSalesReportByParty.fulfilled, (state, action) => {
                state.status = IDS.SLICESTATUS.Succeeded;
                state.sales_report_by_party = action.payload?.data || [];
                state.current_page = action.payload?.current_page || IDS.PAGE;
                state.total_pages = action.payload?.total_pages || IDS.TOTALPAGES;
                state.per_page = action.payload?.per_page || IDS.PERPAGE;
                state.total = action.payload?.total || IDS.TOTAL;
            })
            .addCase(GetSalesReportByParty.rejected, (state, action) => {
                state.status = IDS.SLICESTATUS.Failed;
                state.error = action.payload;
            })


            .addCase(GetSalesReport.pending, (state) => {
                state.status = IDS.SLICESTATUS.Loading;
            })
            .addCase(GetSalesReport.fulfilled, (state, action) => {
                state.status = IDS.SLICESTATUS.Succeeded;
                state.sales_report = action.payload?.data || [];
                state.current_page = action.payload?.current_page || IDS.PAGE;
                state.total_pages = action.payload?.total_pages || IDS.TOTALPAGES;
                state.per_page = action.payload?.per_page || IDS.PERPAGE;
                state.total = action.payload?.total || IDS.TOTAL;
            })
            .addCase(GetSalesReport.rejected, (state, action) => {
                state.status = IDS.SLICESTATUS.Failed;
                state.error = action.payload;
            })

            .addCase(GetPartyReportByItem.pending, (state) => {
                state.status = IDS.SLICESTATUS.Loading;
            })
            .addCase(GetPartyReportByItem.fulfilled, (state, action) => {
                state.status = IDS.SLICESTATUS.Succeeded;
                state.party_report_by_item = action.payload?.data || [];
                state.current_page = action.payload?.current_page || IDS.PAGE;
                state.total_pages = action.payload?.total_pages || IDS.TOTALPAGES;
                state.per_page = action.payload?.per_page || IDS.PERPAGE;
                state.total = action.payload?.total || IDS.TOTAL;
            })
            .addCase(GetPartyReportByItem.rejected, (state, action) => {
                state.status = IDS.SLICESTATUS.Failed;
                state.error = action.payload;
            })

            .addCase(GetStockValueReport.pending, (state) => {
                state.status = IDS.SLICESTATUS.Loading;
            })
            .addCase(GetStockValueReport.fulfilled, (state, action) => {
                state.status = IDS.SLICESTATUS.Succeeded;
                state.stock_value_report = action.payload?.data || [];
                state.current_page = action.payload?.current_page || IDS.PAGE;
                state.total_pages = action.payload?.total_pages || IDS.TOTALPAGES;
                state.per_page = action.payload?.per_page || IDS.PERPAGE;
                state.total = action.payload?.total || IDS.TOTAL;
            })
            .addCase(GetStockValueReport.rejected, (state, action) => {
                state.status = IDS.SLICESTATUS.Failed;
                state.error = action.payload;
            })


            .addCase(GetDailySummary.pending, (state) => {
                state.status = IDS.SLICESTATUS.Loading;
            })
            .addCase(GetDailySummary.fulfilled, (state, action) => {
                state.status = IDS.SLICESTATUS.Succeeded;
                state.daily_summary = action.payload?.data || [];
                state.current_page = action.payload?.current_page || IDS.PAGE;
                state.total_pages = action.payload?.total_pages || IDS.TOTALPAGES;
                state.per_page = action.payload?.per_page || IDS.PERPAGE;
                state.total = action.payload?.total || IDS.TOTAL;
            })
            .addCase(GetDailySummary.rejected, (state, action) => {
                state.status = IDS.SLICESTATUS.Failed;
                state.error = action.payload;
            })
            .addCase(GetAllPartyWiseOutStanding.pending, (state) => {
                state.status = IDS.SLICESTATUS.Loading;
            })
            .addCase(GetAllPartyWiseOutStanding.fulfilled, (state, action) => {
                state.status = IDS.SLICESTATUS.Succeeded;
                state.party_wise_outStanding = action.payload?.data || [];
                state.current_page = action.payload?.current_page || IDS.PAGE;
                state.total_pages = action.payload?.total_pages || IDS.TOTALPAGES;
                state.per_page = action.payload?.per_page || IDS.PERPAGE;
                state.total = action.payload?.total || IDS.TOTAL;
            })
            .addCase(GetAllPartyWiseOutStanding.rejected, (state, action) => {
                state.status = IDS.SLICESTATUS.Failed;
                state.error = action.payload;
            })
            .addCase(GetAllTaxSummary.pending, (state) => {
                state.status = IDS.SLICESTATUS.Loading;
            })
            .addCase(GetAllTaxSummary.fulfilled, (state, action) => {
                state.status = IDS.SLICESTATUS.Succeeded;
                state.tax_summary = action.payload?.data || [];
                state.current_page = action.payload?.current_page || IDS.PAGE;
                state.total_pages = action.payload?.total_pages || IDS.TOTALPAGES;
                state.per_page = action.payload?.per_page || IDS.PERPAGE;
                state.total = action.payload?.total || IDS.TOTAL;
            })
            .addCase(GetAllTaxSummary.rejected, (state, action) => {
                state.status = IDS.SLICESTATUS.Failed;
                state.error = action.payload;
            })


            .addCase(GetAllSalesPurchase.pending, (state) => {
                state.status = IDS.SLICESTATUS.Loading;
            })
            .addCase(GetAllSalesPurchase.fulfilled, (state, action) => {
                state.status = IDS.SLICESTATUS.Succeeded;
                state.sales_purchase = action.payload?.data || [];
                state.current_page = action.payload?.current_page || IDS.PAGE;
                state.total_pages = action.payload?.total_pages || IDS.TOTALPAGES;
                state.per_page = action.payload?.per_page || IDS.PERPAGE;
                state.total = action.payload?.total || IDS.TOTAL;
            })
            .addCase(GetAllSalesPurchase.rejected, (state, action) => {
                state.status = IDS.SLICESTATUS.Failed;
                state.error = action.payload;
            })

            .addCase(GetAllInventoryStock.pending, (state) => {
                state.status = IDS.SLICESTATUS.Loading;
            })
            .addCase(GetAllInventoryStock.fulfilled, (state, action) => {
                state.status = IDS.SLICESTATUS.Succeeded;
                state.inventory_stock = action.payload?.data || [];
                state.current_page = action.payload?.current_page || IDS.PAGE;
                state.total_pages = action.payload?.total_pages || IDS.TOTALPAGES;
                state.per_page = action.payload?.per_page || IDS.PERPAGE;
                state.total = action.payload?.total || IDS.TOTAL;
            })
            .addCase(GetAllInventoryStock.rejected, (state, action) => {
                state.status = IDS.SLICESTATUS.Failed;
                state.error = action.payload;
            })

            .addCase(DowloadPdfInventoryStock.pending, (state) => {
                state.status = IDS.SLICESTATUS.Loading;
            })
            .addCase(DowloadPdfInventoryStock.fulfilled, (state, action) => {
                state.status = IDS.SLICESTATUS.Succeeded;

            })
            .addCase(DowloadPdfInventoryStock.rejected, (state, action) => {
                state.status = IDS.SLICESTATUS.Failed;
                state.error = action.payload;
            })
            .addCase(DowloadXLsInventoryStock.pending, (state) => {
                state.status = IDS.SLICESTATUS.Loading;
            })
            .addCase(DowloadXLsInventoryStock.fulfilled, (state, action) => {
                state.status = IDS.SLICESTATUS.Succeeded;

            })
            .addCase(DowloadXLsInventoryStock.rejected, (state, action) => {
                state.status = IDS.SLICESTATUS.Failed;
                state.error = action.payload;
            });
    },
});

// Export actions (if needed in components)
export const { } = Slice.actions;

export default Slice.reducer;
